import uuid from "react-native-uuid";
// Contants imports
import { DOCUMENTS } from "../constants";

export default (
  state = {
    hoveredActiveComponentId: null,
    clauses: [],
    documentTemplates: [],
    documentTemplatesInfo: {
      pageNum: 1,
      hasMore: false,
    },
    customDynamicFieldData: {},
    defaultSelectStatus: false,
    metaValidStatus: false,
    commonFieldStatus: false,
    dynamicFields: {
      editorState: {},
      fields: [],
      customDynamicFields: {
        common: {},
        meta: {},
      },
      isOpen: false,
      section: {},
      selectedText: "",
      view: "LIST",
      selectedDynamicFieldForUpdate: {},
    }, // Holds the data needed for dynamic field
    template: {},
    clauseOptions: {
      section: null,
      isOpen: false,
      clause: null,
    },
    imageFormField: {
      section: null,
      isOpen: false,
      clause: null,
      blockType: null,
      blockID: null,
    },
    workflow: {
      users: [],
      entity: {},
      metaData: {},
      formFields: [],
      workflowDetails: {},
      showWorkFlowScreen: false,
    },
    // Editor active/inactive flags
    clickedActiveComponentId: null,
    // id to reload on unodo redo
    undoRedoId: "",
    templateSearchSuggestions: null,
    templateSearchContent: null,
    searchTerm: "",
    globalTemplates: [],
  },
  action,
) => {
  switch (action.type) {
    case "TEMPLATE_INIT_DATA":
      return { ...state, documentTemplates: action.payload };
    case "FETCH_DOCUMENT_TEMPLATES":
      return {
        ...state,
        documentTemplates: action.payload.templates,
        documentTemplatesInfo: {
          hasMore: action.payload.hasMore,
          pageNum: action.payload.pageNum,
        },
      };
    case "LOAD_MORE_DOCUMENT_TEMPLATES":
      return {
        ...state,
        documentTemplates: [
          ...state.documentTemplates,
          ...action.payload.templates,
        ],
        documentTemplatesInfo: {
          hasMore: action.payload.hasMore,
          pageNum: action.payload.pageNum,
        },
      };
    case "FETCH_TEMPLATE_DETAILS":
      return {
        ...state,
        template: {
          ...action.payload.template,
          meta_data: action.payload.template.meta_data || {},
        },
        dynamicFields: {
          ...state.dynamicFields,
          fields: action.payload.fields,
        },
      };
    case "TEMPLATES_LIST_STATUS_CHANGE":
      return { ...state, documentTemplates: action.payload };
    case "TEMPLATE_STATUS_CHANGE":
      return {
        ...state,
        template: { ...state.template, status: action.payload },
      };
    case "PUBLISH_TEMPLATE":
      return {
        ...state,
        template: {
          ...state.template,
          template_type: action.payload,
          status: "ACTIVE",
        },
      };
    case "DELETE_TEMPLATE":
      return { ...state, documentTemplates: action.payload };
    case "UPDATE_DOCUMENT_CONTENT": {
      const template = {
        ...state.template,
        content: {
          schema_version: DOCUMENTS.DOCUMENT_SCHEMA_VERSION,
          sections: action.payload.sections,
        },
      };
      return {
        ...state,
        template,
      };
    }
    case "ADD_COMPONENT_IN_TEMPLATE": {
      const newSectionList = action.payload.newSectionList.map(sectionID =>
        sectionID === action.payload.newSection.id
          ? action.payload.newSection
          : state.template.content.sections.find(
              section => section.id === sectionID,
            ),
      );
      let tempActiveSectionID = state.activeSectionID;
      const { headerFooterType, newSection } = action.payload;
      // Don't update "hoveredActiveComponentId" in case of EmptyContainer
      if (newSection.type !== "EmptyContainer") {
        tempActiveSectionID = action.payload.newSection.id;
        // If it is a case of add HeaderFooter then,
        // need to update the id of default text of header/footer as "hoveredActiveComponentId"
        if (newSection.type === "HeaderFooter") {
          const { data } = newSection;
          let headerFooterData = [];
          if (headerFooterType === "HEADER") {
            headerFooterData = data.header.data;
          } else if (headerFooterType === "FOOTER") {
            headerFooterData = data.footer.data;
          }
          if (headerFooterData && headerFooterData.length > 0) {
            tempActiveSectionID = headerFooterData[1].id;
          }
        }
      }

      return {
        ...state,
        template: {
          ...state.template,
          content: { ...state.template.content, sections: newSectionList },
        },
        hoveredActiveComponentId: tempActiveSectionID,
      };
    }
    case "UPDATE_SECTION_IN_TEMPLATE": {
      const { section, addedNewTextSection } = action.payload;
      const {
        template: { content },
      } = state;
      let tempActiveSectionID = state.hoveredActiveComponentId;
      /**
       * In CoverPage and Header/Footer adding a new component behaves like update the component, so need to handle this,
       * If there is a case of add new component then, update the new component's id as "hoveredActiveComponentId"
       */
      if (
        addedNewTextSection &&
        (section.type === "CoverPage" || section.type === "HeaderFooter") &&
        (addedNewTextSection.type === "HTML" ||
          addedNewTextSection.type === "Table")
      ) {
        tempActiveSectionID = addedNewTextSection.id;
      }
      if (content && content.sections && section) {
        return {
          ...state,
          template: {
            ...state.template,
            content: {
              ...state.template.content,
              sections: state.template.content.sections.map(sec =>
                sec.id === section.id ? section : sec,
              ),
            },
          },
          hoveredActiveComponentId: tempActiveSectionID,
        };
      }
      return state;
    }

    case "REMOVE_COMPONENT_IN_TEMPLATE":
      return {
        ...state,
        template: {
          ...state.template,
          content: {
            ...state.template.content,
            sections: state.template.content.sections.filter(
              section => section.id !== action.payload,
            ),
          },
        },
      };
    case "UPDATE_TEMPLATE_CLAUSES":
      return { ...state, clauses: action.payload };
    case "ADD_TEMPLATE_CLAUSES": {
      const { clauses } = state;
      clauses.push(action.payload);
      return { ...state, clauses };
    }
    case "REMOVE_TEMPLATE_CLAUSES": {
      return {
        ...state,
        clauses: state.clauses.filter(clause => clause.id !== action.payload),
      };
    }

    case "UPDATE_TEMPLATE_TITLE":
      return {
        ...state,
        template: { ...state.template, title: action.payload },
      };

    case "UPDATE_TEMPLATE_META":
      return {
        ...state,
        template: { ...state.template, meta_data: action.payload.meta_data },
      };

    case "NUKE_TEMPLATE":
      return {
        ...state,
        template: {},
        dynamicFields: {
          ...state.dynamicFields,
          fields: [],
        },
      };

    case "UPDATE_HOVERED_TEMPLATE_SECTION_ID": {
      const { sectionID, updateAfterSection } = action.payload;
      const { hoveredActiveComponentId } = state;
      let newActiveSecId = sectionID;
      if (updateAfterSection) {
        if (
          hoveredActiveComponentId &&
          hoveredActiveComponentId === sectionID
        ) {
          newActiveSecId = null;
        } else {
          newActiveSecId = hoveredActiveComponentId;
        }
      }
      return { ...state, hoveredActiveComponentId: newActiveSecId };
    }
    case "UPDATE_TEMPLATE_SECTION_LABEL":
      return {
        ...state,
        template: {
          ...state.template,
          content: {
            ...state.template.content,
            sections: state.template.content.sections.map(section => {
              if (section.id !== action.payload.sectionID) {
                return section;
              }
              return {
                ...section,
                label: action.payload.label,
              };
            }),
          },
        },
      };

    case "REORDER_TEMPLATE_SECTIONLIST": {
      const {
        template: {
          content: { sections },
        },
      } = state;
      const sectionList = action.payload.sectionList.map(sectionID =>
        sections.find(section => section.id === sectionID),
      );
      return {
        ...state,
        template: {
          ...state.template,
          content: { ...state.template.content, sections: sectionList },
        },
      };
    }

    //* Dynamic Filed Actions

    case "ADD_DYNAMIC_FIELD":
      return {
        ...state,
        dynamicFields: {
          ...state.dynamicFields,
          editorState: action.payload.editorState,
          isOpen: true,
          section: action.payload.section,
          selectedText: action.payload.selectedText,
          removeHighlightSelection: action.payload.removeHighlightSelection,
          view: "SELECT",
          selectedDynamicFieldForUpdate: {},
        },
      };

    // add clause options
    case "ADD_CLAUSE_OPTIONS": {
      const { component } = action.payload;
      return {
        ...state,
        clauseOptions: {
          ...state.clauseOptions,
          isOpen: true,
          section: component || state.clauseOptions.section,
        },
      };
    }

    // convert to image field
    case "CONVERT_TO_IMAGE_FIELD": {
      const { section, blockType, blockID } = action.payload;
      return {
        ...state,
        imageFormField: {
          ...state.imageFormField,
          isOpen: true,
          section: section || state.imageFormField.section,
          blockType,
          blockID,
        },
      };
    }

    case "EDIT_CLAUSE_OPTIONS": {
      return {
        ...state,
        clauseOptions: {
          clause: action.payload.clauseOptions,
          isOpen: true,
          section: action.payload.section,
          blockID: action.payload.blockID,
          blockType: action.payload.blockType,
        },
      };
    }

    case "EDIT_IMAGE_FORM_FIELD": {
      return {
        ...state,
        imageFormField: {
          clause: action.payload.clauseOptions,
          isOpen: true,
          section: action.payload.section,
          blockID: action.payload.blockID,
          blockType: action.payload.blockType,
        },
      };
    }

    case "UPDATE_TEMPLATE_SECTION_WITH_DYNAMIC_FIELD":
      return {
        ...state,
        dynamicFields: {
          ...state.dynamicFields,
          view: "LIST",
        },
      };

    case "CHANGE_DYNAMIC_FIELD_VIEW":
      return {
        ...state,
        dynamicFields: { ...state.dynamicFields, view: action.payload },
      };

    case "SELECTED_DYNAMIC_FIELD_DATA_FOR_UPDATE":
      return {
        ...state,
        customDynamicFieldData: {},
        dynamicFields: {
          ...state.dynamicFields,
          selectedDynamicFieldForUpdate: action.payload,
        },
      };

    case "FETCH_CUSTOM_FIELD":
      return {
        ...state,
        dynamicFields: {
          ...state.dynamicFields,
          customDynamicFields: action.payload,
        },
      };
    case "ADD_DYNAMIC_FIELD_IN_LIST": {
      let {
        template: { fields_used: fieldsUsed },
        dynamicFields: { fields },
      } = state;
      if (!fieldsUsed) fieldsUsed = [];
      if (!fields) fields = [];
      const field = action.payload;
      if (!(fields.findIndex(f => f.id === field.id) > -1)) fields.push(field);
      if (!(fieldsUsed.findIndex(f => f.id === field.id) > -1))
        fieldsUsed.push(field);
      return {
        ...state,
        template: { ...state.template, fields_used: fieldsUsed },
        dynamicFields: { ...state.dynamicFields, fields },
      };
    }
    case "UPDATE_DYNAMIC_FIELD_IN_LIST": {
      const {
        template: { fields_used: fieldsUsed },
        dynamicFields: { fields },
      } = state;
      if (fields && fields.length > 0) {
        for (let b = 0; b < fields.length; b += 1) {
          if (fields[b].id === action.payload.id) {
            fields[b] = action.payload;
            break;
          }
        }
      }
      if (fieldsUsed && fieldsUsed.length > 0) {
        for (let b = 0; b < fieldsUsed.length; b += 1) {
          if (fieldsUsed[b].id === action.payload.id) {
            fieldsUsed[b] = action.payload;
            break;
          }
        }
      }
      return {
        ...state,
        template: { ...state.template, fields_used: fieldsUsed },
        dynamicFields: { ...state.dynamicFields, fields },
      };
    }
    case "NUKE_CLAUSE_OPTIONS":
      return {
        ...state,
        clauseOptions: { clause: null, isOpen: false, section: null },
      };
    case "NUKE_IMAGE_FORM_FIELD":
      return {
        ...state,
        imageFormField: { clause: null, isOpen: false, section: null },
      };
    case "SET_COMMON_FIELDS":
      return {
        ...state,
        customDynamicFieldData: {
          ...state.customDynamicFieldData,
          common: action.payload,
        },
      };

    case "SET_META_FIELDS":
      return {
        ...state,
        customDynamicFieldData: {
          ...state.customDynamicFieldData,
          meta: action.payload,
        },
      };

    case "NUKE_DYNAMIC_FIELD_DATA":
      return {
        ...state,
        customDynamicFieldData: {},
        defaultSelectStatus: false,
        metaValidStatus: false,
        commonFieldStatus: false,
      };

    case "SET_FLAG_FOR_DEFAULT":
      return { ...state, defaultSelectStatus: action.payload };

    case "META_VALID_STATUS":
      return { ...state, metaValidStatus: action.payload };

    case "SET_FLAG_FOR_COMMON_FIELDS":
      return { ...state, commonFieldStatus: action.payload };

    case "UPDATE_CLAUSE_OPTIONS_AND_SECTION": {
      const { clauseOption } = action.payload;
      const {
        template: {
          // content: { sections },
          fields_used: fieldsUsed,
        },
        dynamicFields: { fields },
      } = state;

      // update section
      // const updatedSections = sections.map(sec =>
      //   section.id === sec.id ? section : sec,
      // );

      // update clause options
      const optionIndex = fields.findIndex(
        field => field.id === clauseOption.id,
      );
      // avoiding mutation in state
      const newFields = fields.slice();

      if (optionIndex > -1) {
        newFields.splice(optionIndex, 1, clauseOption);
      } else {
        newFields.push(clauseOption);
      }

      const fieldsUsedIndex = fieldsUsed.findIndex(
        field => field.id === clauseOption.id,
      );
      const newFieldsUsed = fieldsUsed.slice();
      if (fieldsUsedIndex > -1) {
        newFieldsUsed.splice(fieldsUsedIndex, 1, clauseOption);
      }

      return {
        ...state,
        template: {
          ...state.template,
          // content: {
          //   ...state.template.content,
          //   // sections: updatedSections,
          // },
          fields_used: newFieldsUsed,
        },
        dynamicFields: { ...state.dynamicFields, fields: newFields },
        clauseOptions: { section: null, isOpen: false, clause: null },
      };
    }

    case "UPDATE_IMAGE_FORM_FIELD_AND_SECTION": {
      const { imageFormField } = action.payload;
      const {
        template: { fields_used: fieldsUsed },
        dynamicFields: { fields },
      } = state;

      // update clause options
      const optionIndex = fields.findIndex(
        field => field.id === imageFormField.id,
      );
      // avoiding mutation in state
      const newFields = fields.slice();

      if (optionIndex > -1) {
        newFields.splice(optionIndex, 1, imageFormField);
      } else {
        newFields.push(imageFormField);
      }

      const fieldsUsedIndex = fieldsUsed.findIndex(
        field => field.id === imageFormField.id,
      );
      const newFieldsUsed = fieldsUsed.slice();
      if (fieldsUsedIndex > -1) {
        newFieldsUsed.splice(fieldsUsedIndex, 1, imageFormField);
      }

      return {
        ...state,
        template: {
          ...state.template,
          fields_used: newFieldsUsed,
        },
        dynamicFields: { ...state.dynamicFields, fields: newFields },
        imageFormField: { section: null, isOpen: false, clause: null },
      };
    }

    // Workflow related cases
    case "TOGGLE_TEMP_WORKFLOW_SCREEN":
      return {
        ...state,
        workflow: {
          ...state.workflow,
          showWorkFlowScreen: action.payload.flag,
          entity: action.payload.entity,
        },
      };
    case "UPDATE_TEMPLATE_ENTITY":
      return {
        ...state,
        workflow: {
          ...state.workflow,
          entity: { ...state.workflow.entity, wfId: action.payload },
        },
      };
    case "REACTION_TEMP_WORKFLOW_INIT_DATA":
      return {
        ...state,
        workflow: {
          ...state.workflow,
          formFields: action.payload.formFields,
          metaData: action.payload.metaData,
          userGroups: action.payload.userGroups,
          users: action.payload.users,
          workflowDetails: action.payload.workflowData,
        },
      };
    case "UPDATE_TEMP_WORKFLOW_RULE":
      return {
        ...state,
        workflow: {
          ...state.workflow,
          workflowDetails: {
            ...state.workflow.workflowDetails,
            rules: action.payload.workflowData,
          },
          formFields: action.payload.formFields,
        },
      };

    case "UPDATE_TEMP_WORKFLOW_FORMFIELDS":
      return {
        ...state,
        workflow: { ...state.workflow, formFields: action.payload },
      };
    case "NUKE_TEMP_WORKFLOW_FORMFIELDS":
      return {
        ...state,
        workflow: { ...state.workflow, formFields: [], workflowDetails: {} },
      };
    case "UPDATE_TEMP_USEDFIELDS":
      return {
        ...state,
        template: { ...state.template, fields_used: action.payload },
      };
    case "REMOVE_HIGHLIGHT_IN_TEMPLATE":
      return {
        ...state,
        template: {
          ...state.template,
          content: {
            ...state.template.content,
            sections: state.template.content.sections.map(section => {
              if (section.id === action.payload.id) return action.payload;
              return section;
            }),
          },
        },
        hoveredActiveComponentId: action.payload.id,
      };

    case "UPDATE_TEMPLATE_ACTIVE_EDITOR_ID":
      return { ...state, clickedActiveComponentId: action.payload };

    // case "UPDATE_STYLE_COMPONENTS_TEMPLATE_SECTION": {
    //   return {
    //     ...state,
    //     template: {
    //       ...state.template,
    //       content: {
    //         ...state.template.content,
    //         sections: state.template.content.sections.map(section => {
    //           if (section.type !== action.payload.sectionType) {
    //             return section;
    //           }
    //           return action.payload.newSection;
    //         }),
    //       },
    //     },
    //   };
    // }
    case "UPDATE_TEMPLATE_TAG":
      // return { ...state, documentTemplates: action.payload };
      return {
        ...state,
        documentTemplates: state.documentTemplates.map(item => {
          if (action.payload.templateId === item.id) {
            return {
              ...item,
              template_tag: action.payload.newTag,
            };
          }
          return item;
        }),
      };
    case "UPDATE_TEMPLATE_USER_GROUP":
      return {
        ...state,
        documentTemplates: state.documentTemplates.map(item => {
          if (action.payload.templateId === item.id) {
            return {
              ...item,
              usergroups: action.payload.stateData,
            };
          }
          return item;
        }),
      };
    case "UPDATE_TEMAPLATE_DOC_SECTION_LOCK_UNLOCK": {
      return {
        ...state,
        template: {
          ...state.template,
          content: {
            ...state.template.content,
            sections: action.payload.sections,
          },
        },
      };
    }
    case "REACTION_ON_TEMPLATE_UNDO_ACTION":
    case "REACTION_ON_TEMPLATE_REDO_ACTION": {
      return {
        ...state,
        template: {
          ...state.template,
          content: {
            ...state.template.content,
            sections: action.payload.sections,
          },
        },
        undoRedoId: uuid.v4(),
      };
    }

    case "UPDATE_TEMPLATE_SEARCH_SUGGESTIONS":
      return {
        ...state,
        templateSearchSuggestions: action.payload.templateSearchSuggestions,
      };

    case "UPDATE_TEMPLATE_SEARCH_CONTENT":
      return {
        ...state,
        templateSearchContent: action.payload.templateSearchContent,
        documentTemplates: action.payload.templates,
        searchTerm: action.payload.searchTerm,
      };

    case "CLEAR_SEARCH_TERM":
      return { ...state, searchTerm: "" };

    case "UPDATE_GLOBAL_TEMPLATES":
      return { ...state, globalTemplates: action.payload.globalTemplates };

    case "UPDATE_GLOBAL_TEMPLATE_SEARCH_CONTENT":
      return {
        ...state,
        globalTemplates: action.payload.globalTemplates,
        templateSearchContent: action.payload.templateSearchContent,
        searchTerm: action.payload.searchTerm,
      };

    case "COVERPAGE_THEME_ACTION":
      return { ...state, coverpageThemeActionLabel: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/TemplateReducer.js